import { GET_MEETING_LOCATION_URL, UPDATE_OR_DELETE_MEETING_LOCATION_URL } from "services/url.service";
import { commonTransform } from "../handleTransformation";
import { tags } from "../constants";

export const meetingLocationQueries = {
  getMeetingLocations: {
    getUrl: ({companyId, search, offset, limit}) =>  GET_MEETING_LOCATION_URL(companyId, search, offset, limit),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.MEETING_LOCATIONS]
  },
};

export const meetingLocationMutations = {
  createMeetingLocation: {
    getUrl: ({companyId, location}) =>  GET_MEETING_LOCATION_URL(companyId, location),
    transformResponse: (res) => commonTransform(res),
    method: "POST",
    invalidatesTags: [tags.MEETING_LOCATIONS]
  },
  deleteMeetingLocation: {
    getUrl: ({companyId, id}) =>  UPDATE_OR_DELETE_MEETING_LOCATION_URL(companyId, id),
    transformResponse: (res) => commonTransform(res),
    method: "DELETE",
    invalidatesTags: [tags.MEETING_LOCATIONS]
  },
  updateMeetingLocation: {
    getUrl: ({companyId, id, location}) =>  UPDATE_OR_DELETE_MEETING_LOCATION_URL(companyId, id, location),
    transformResponse: (res) => commonTransform(res),
    method: "PUT",
    invalidatesTags: [tags.MEETING_LOCATIONS]
  },
};
